<template>
<div id="custom" class="custom">
  <div class="custom__head">
    <router-link
      v-if="Object.keys(custom).length > 0"
      :to="{ name: 'item-detail', params: { id: custom.id } }"
      class="custom__head__close">Close</router-link>
    <h2 class="custom__head__ttl">CUSTOMIZE</h2>
    <div class="custom__head__sub">
      <div class="custom__head__sub__bl" @click="showSyncModal">
        <img src="@/assets/images/custom/custom-mirror.svg" alt="Mirror" />
      </div>
      <div @click="compCustom" class="custom__head__sub__bl">
        <img src="@/assets/images/custom/custom-check.svg" alt="Preview" />
      </div>
    </div>
  </div><!--  ヘッダーエリアここまで  -->

  <div id="canvas" class="canvas">
    <div class="canvas__info">
      <div class="canvas__info__txt">{{ scenePop }}</div>
      <div class="canvas__info__msg">{{ infoMsg }}</div>
    </div>
    <div class="canvas__area">
      <div id="canvasWrap" class="canvas__area__wrap">
        <canvas id="canvas-board" class="canvas__area__wrap__item">
          このブラウザはCanvasがサポートされていないため表示できません
        </canvas>
      </div>
      <div
        v-if="Object.keys(custom).length > 0"
        id="prev-scene-btn"
        class="canvas__area__left"
        @click="prevScene">
        <img v-if="totalScene > 1" src="@/assets/images/custom/custom-left.svg" alt="left" />
      </div>
      <div
        v-if="Object.keys(custom).length > 0"
        id="next-scene-btn"
        class="canvas__area__right"
        @click="nextScene">
        <img v-if="totalScene > 1" src="@/assets/images/custom/custom-right.svg" alt="right" />
      </div>
      <div v-if="nonSelectable" class="partsImageLoading">Loading...</div>
    </div>
  </div><!--  描画エリアここまで  -->

  <div class="custom__menu">
    <div class="custom__menu__display">
      <div class="custom__menu__display__left">
        <div class="custom__menu__display__left__logo"><img :src="item.brandMainImage" :alt="item.brandName" /></div>
        <p class="custom__menu__display__left__price">¥ {{ custom.amount | formatPrice(item.tax) }}</p>
      </div>
      <div class="custom__menu__display__scale">
        <div v-if="isScaleZoom === false" class="custom__menu__display__scale__icn" @click="scaleZoom">
          <img src="@/assets/images/custom/custom-zoom.svg" alt="zoom" />
        </div>
        <div v-if="isScaleZoom === true" class="custom__menu__display__scale__icn" @click="scaleDown">
          <img src="@/assets/images/custom/custom-down.svg" alt="down" />
        </div>
      </div>
    </div>

    <div class="custom__menu__panel">
      <div
        v-for="(tab, index) in item.parts"
        :key="tab.label"
        v-if="tab.isShowMenu"
        :class="{ 'is-active': index === active }"
        class="custom__menu__panel__2">
        <div class="custom__menu__panel__2__ct">
          <div class="custom__menu__panel__2__ct__vals">

            <dl
              v-for="select in tab.selects"
              :key="select.selectID"
              @click="updateSelectParts(tab.id, select.selectID, tab.relatedScene, tab.label)"
              :class="{ 'is-active': findSelectParts(select.selectID) && findSelectParts(select.selectID).type === 'type1',
                        'is-sold': getStock(tab.id, select.selectID) === 0,
                        'non-selectable': nonSelectable === true }"
              class="custom__menu__panel__2__ct__vals__val">
              <dd class="custom__menu__panel__2__ct__vals__val__img">
                <img :src="select.thumbnail" :alt="select.name" />
              </dd>
              <dt :id="'selectName-' + select.selectID">{{ select.name | breakWord('selectName-' + select.selectID) }}</dt>
              <dd v-if="select.price > 0 && tab.baseItem === false">+￥{{ select.price | formatPrice(item.tax) }}</dd>
            </dl>

          </div>
        </div>
      </div>

      <div class="custom__menu__panel__1">
        <div class="custom__menu__panel__1__ct">
          <div
            v-for="(tab, index) in item.parts"
            :key="tab.label"
            v-if="tab.isShowMenu"
            @click="active = index"
            :class="{ 'is-active': index === active }"
            class="custom__menu__panel__1__ct__item">{{ tab.label }}</div>
        </div>
      </div>

    </div>
  </div><!--  メニューエリアここまで  -->

  <!--  以下、モーダルコンポーネント  -->
  <Loading
    v-if="isLoading" />
  <Modal
    v-if="showModal"
    :modalObject="modalObject"
    @close="showModal = false, modalObject = {
      title: '', content: '', routerLink: '', href: '', showNo: false, showOk: false
    }" />
  <ExplainModal
    v-if="isExplainModal"
    @hideExplain="isExplainModal = false" />
  <EmbModal
    v-if="Object.keys(embData).length > 0"
    :embData="embData"
    @clickClose="clearEmbData"
    @updateEmbData="updateEmbData" />
  <SyncModal
    v-if="isSyncModal"
    @close="hideSyncModal"
    target="sp"
    :customID="custom['customID']" />
  <LockModal
    v-if="custom['signageState'] || custom['cartInState']" target="sp" />
</div>
</template>

<script>
import Loading from '@/components/Loading'
import Modal from '@/components/Modal'
import ExplainModal from '@/components/ExplainModal'
import EmbModal from '@/components/EmbModal'
import SyncModal from '@/components/SyncModal'
import LockModal from '@/components/LockModal'

import customMgr from '@/modules/CustomManager.js'
import CanvasHandler from '@/assets/class/CanvasHandler'

const ch = new CanvasHandler()

export default {
  components: {
    Loading,
    Modal,
    ExplainModal,
    EmbModal,
    SyncModal,
    LockModal
  },
  data () {
    return {
      id: '',
      item: {},
      custom: {},
      embData: {},
      active: 0,
      canvasWidth: 0,
      canvasHeight: 0,
      sceneNum: 0,
      switchScene: false,
      scenePop: '正面',
      infoMsg: '',
      timeoutID: 0,
      isScaleZoom: false,
      isLoading: false,
      isExplainModal: false,
      isSyncModal: false,
      showModal: false,
      modalObject: {
        title: '', content: '', routerLink: '', href: '', showNo: false, showOk: false
      },
      nonSelectable: false
    }
  },
  beforeRouteEnter (to, from, next) {
    /*
    * アプリ内の詳細画面から遷移した場合
    */
    if (typeof to.query.id !== 'undefined') {
      customMgr.getItem(String(to.query.id)).then((item) => {
        return item
      }).then(item => {
        const initData = []
        initData[0] = item
        customMgr.getNewCustomItemFromApp(to.query.id).then(customItem => {
          initData[1] = customItem
          next(vm => vm.setDatas(initData))
        })
      })

    /*
    * ECから遷移してきた場合
    */
    } else if (
      typeof to.query.ggcd !== 'undefined' &&
      typeof to.query.gcd !== 'undefined'
    ) {
      // http://localhost:8080/custom?ggcd=ebird001&gcd=ebird001-00001

      customMgr.getNewCustomItemFromEC(to.query.ggcd, to.query.gcd).then(customItem => {
        const initData = []
        initData[1] = customItem

        customMgr.getItem(customItem.id).then((item) => {
          initData[0] = item
          next(vm => vm.setDatas(initData))
        }).catch(() => {
          next({ name: 'not-found' })
        })
      }).catch(() => {
        next({ name: 'not-found' })
      })

    /*
    * customIDから遷移してきた場合
    */
    } else if (typeof to.query.customid !== 'undefined') {
      customMgr.getCustomItem(to.query.customid).then((customItem) => {
        return customItem
      }).then(customItem => {
        const initData = []
        const deviceID = customMgr.getDeviceID()
        initData[1] = customItem

        // DeviceIDを使ってロックを掛ける場合設定（本番用）
        if (initData[1]['deviceID'] !== '' && initData[1]['deviceID'] !== deviceID && Boolean(to.query.signage) === false) {
          throw new Error('No matched deviceID')
        }

        // スマートミラーから遷移してきた場合
        if (initData[1]['deviceID'] !== '' && Boolean(to.query.signage) === true) {
          initData[1]['signageState'] = false // Customで表示した場合は必ずfalseにする

          if (initData[1]['deviceID'] === '') { // 空の場合は自分のdeviceIDに置き換える
            initData[1]['deviceID'] = deviceID
          }

          customMgr.setCustomItemValue(to.query.customid, 'signageState', false).then(() => {
            console.log(to.query.customid + ' signageState: false')
          })
          customMgr.setCustomItemValue(to.query.customid, 'customID', initData[1]['getDeviceID']).then(() => {
            console.log(to.query.customid + ' signageState: false')
          })
        }

        customMgr.getItem(customItem.id).then((item) => {
          initData[0] = item
          next(vm => vm.setDatas(initData))
        }).catch(() => {
          next({ name: 'not-found' })
        })
      }).catch(() => {
        next({ name: 'not-found' })
      })
    }
  },
  computed: {
    optionParts () {
      return this.item.parts
    },
    selectParts () {
      return this.custom.parts
    },
    baseItem () {
      return this.selectParts.find(element => element.baseItem === true)
    },
    totalScene () {
      return this.baseItem.scene.length
    },
    sceneLabel () {
      return this.baseItem.scene.find(element => element.sceneNumber === this.sceneNum).label
    }
  },
  watch: {
    selectParts: {
      handler () {
        this.$nextTick(() => {
          this.custom.amount = ch.calcAmount(this.custom.parts)
        })
      }
    },
    sceneNum: {
      handler () {
        this.scaleDown()
        this.scenePop = this.sceneLabel
        ch.drawBitmapToStage(this.item.parts, this.custom.parts, this.sceneNum)
        this.switchScene = false // シーン切り替えフラグを戻す
      }
    },
    infoMsg: {
      handler () {
        clearTimeout(this.timeoutID)
        this.timeoutID = setTimeout(() => {
          this.infoMsg = ''
        }, 3000)
      }
    }
  },
  filters: {
    breakWord (text, id) {
      const targetElement = document.getElementById(id)
      if (targetElement !== null && text.length > 10) {
        text = text.slice(0, 10) + '<br />' + text.slice(10)
        document.getElementById(id).innerHTML = text
      } else {
        return text
      }
    }
  },
  methods: {
    // 初期データのセット
    setDatas (initData) {
      this.item = initData[0]
      this.custom = initData[1]
    },
    // 選択中のアイテムをチェックする
    findSelectParts (selectID) { return ch.findSelectParts(this.custom.parts, selectID) },
    // 在庫の数を取得する
    getStock (itemID, selectID) {
      const targetItem = this.optionParts.find(element => element.id === itemID)
      const targetSelect = targetItem.selects.find(element => element.selectID === selectID)
      return targetSelect.stock
    },
    // 一時的なメッセージをセットする
    setInfoMessage (msg) { this.infoMsg = msg },
    // アイテムをクリックして選択した時、カスタムデータをアップデート
    updateSelectParts (partsID, selectID, sceneNum, menuLabel) {
      if (sceneNum !== -1) {
        if (this.sceneNum !== sceneNum) this.switchScene = true // シーン切り替えフラグをオンへ
        this.sceneNum = sceneNum
      }
      /** Epoiの特殊実装ここから */
      if (this.item.brandName === 'Epoi' && (menuLabel === '表革' || menuLabel === '引き手')) {
        const selectPartsDataArray = ch.createSelectPartsDataEpoi(this.item.parts, this.custom.parts, partsID, selectID, menuLabel)
        selectPartsDataArray.forEach(selectPartsData => {
          const updateIndex = this.custom.parts.findIndex(element => element.id === selectPartsData.id)
          if (!this.switchScene) ch.addBitmapToStage(selectPartsData, this.custom.parts[updateIndex], this.sceneNum)
          this.custom.parts.splice(updateIndex, 1, selectPartsData)
        })
        return false
      }
      /** Epoiの特殊実装ここまで */
      const usableScene = this.item.parts.find(element => element.id === partsID).usableScene
      if (usableScene.indexOf(this.sceneNum) === -1) {
        this.setInfoMessage('この面に貼ることはできません')
        return false
      }
      const selectPartsData = ch.createSelectPartsData(this.item.parts, partsID, selectID, this.scenePop, this.sceneNum)
      if (selectPartsData.type === 'type1') {
        const updateIndex = this.custom.parts.findIndex(element => element.id === selectPartsData.id)
        if (updateIndex === -1) {
          if (!this.switchScene) ch.addBitmapToStage(selectPartsData, null, this.sceneNum)
          this.custom.parts.push(selectPartsData)
        } else {
          if (!this.switchScene) ch.addBitmapToStage(selectPartsData, this.custom.parts[updateIndex], this.sceneNum)
          this.custom.parts.splice(updateIndex, 1, selectPartsData)
        }
      }
      if (selectPartsData.type === 'type2') {
        if (!this.switchScene) ch.addBitmapToStage(selectPartsData, null, this.sceneNum)
        this.custom.parts.push(selectPartsData)
      }
      if (selectPartsData.type === 'type3') {
        this.embData = selectPartsData // 刺繍データは子コンポーネントでテキスト入力後、子コンポーネントからカスタムデータを書き換える
      }
    },
    // アイテムの連続2回押しができないようにする
    changeStateSelectable (selectableState) { this.nonSelectable = selectableState },
    // embDataオブジェクトを空にする（刺繍用のモーダルを閉じる）
    clearEmbData () {
      this.embData = {}
    },
    // 刺繍テキスト入力後にカスタムデータに挿入
    updateEmbData (inputText) {
      this.scaleZoom()
      ch.shiftHorizontalCenter(this.embData.scene[0].x)
      this.embData.embroidery.inputText = inputText
      const updateIndex = this.custom.parts.findIndex(element => element.id === this.embData.id)
      if (updateIndex === -1) {
        if (!this.switchScene) ch.addBitmapToStage(this.embData, null, this.sceneNum)
        this.custom.parts.push(this.embData)
      } else {
        if (!this.switchScene) ch.addBitmapToStage(this.embData, this.custom.parts[updateIndex], this.sceneNum)
        this.custom.parts.splice(updateIndex, 1, this.embData)
      }
      this.embData = {}
    },
    // ワッペンの座標位置をアップデート
    updateLocation (selectID, beforeX, beforeY, afterX, afterY) {
      let breakFlag = false
      this.custom.parts.some(partsElement => {
        if (partsElement.selectID === selectID) {
          partsElement.scene.some(sceneElement => {
            if (Math.round(sceneElement.x) === Math.round(beforeX) &&
                Math.round(sceneElement.y) === Math.round(beforeY)) {
              sceneElement.x = afterX
              sceneElement.y = afterY
              breakFlag = true
            }
          })
          return breakFlag
        }
      })
    },
    // ワッペンの回転角度をアップデート
    updateRotation (selectID, x, y, degrees) {
      const filterBySelectID = this.custom.parts.filter(element => element.selectID === selectID)
      filterBySelectID.forEach(partsElement => {
        partsElement.scene.forEach(sceneElement => {
          if (sceneElement.x === x && sceneElement.y === y) {
            sceneElement.rotate = degrees
          }
        })
      })
    },
    // 選択されたパーツをデータから削除
    deleteParts (selectID, x, y) {
      const filterBySelectID = this.custom.parts.filter(element => element.selectID === selectID)
      filterBySelectID.some(element => {
        const deleteIndex = element.scene.findIndex(sceneElement => sceneElement.x === x && sceneElement.y === y)
        if (deleteIndex !== -1) {
          if (!this.switchScene) ch.deleteBitmapFromStage(element, this.sceneNum)
          this.custom.parts.splice(this.custom.parts.indexOf(element), 1)
          return true
        }
      })
    },
    // 拡大ボタン押下時
    scaleZoom () {
      if (this.isScaleZoom === false) {
        ch.resizeStage(this.canvasWidth * 2, this.canvasHeight * 2)
        ch.resizeBitmap()
        this.isScaleZoom = true
      }
    },
    // 縮小ボタン押下時
    scaleDown () {
      if (this.isScaleZoom === true) {
        ch.resizeStage(this.canvasWidth, this.canvasHeight)
        ch.resizeBitmap()
        this.isScaleZoom = false
      }
    },
    // 前のシーンに切り替え
    prevScene () {
      if (!this.nonSelectable) {
        if (this.sceneNum === 0) {
          this.sceneNum = this.totalScene - 1
        } else {
          this.sceneNum--
        }
      }
    },
    // 次のシーンに切り替え
    nextScene () {
      if (!this.nonSelectable) {
        if (this.sceneNum >= this.totalScene - 1) {
          this.sceneNum = 0
        } else {
          this.sceneNum++
        }
      }
    },
    // canvasを画像に変換&画像データをcustomデータにセット、customデータをDBへ保存
    saveCustomData () {
      this.isLoading = true
      return new Promise((resolve, reject) => {
        ch.createSaveImages('canvas-board', this.custom.parts, this.totalScene).then(customImageArray => {
          this.custom.customImage = customImageArray
          this.custom.deviceID = customMgr.getDeviceID() // ユーザデバイス側は保存するたびに必ずdeviceIDを挿入する
          customMgr.setCustomItem(this.custom).then(() => {
            this.isLoading = false
            resolve()
          }).catch(() => {
            this.showModal = true
            this.modalObject.title = 'データ保存に失敗しました'
            this.modalObject.content = 'もう一度お試しいただくか、しばらく経ってから保存してください。'
            this.modalObject.showOk = true

            reject(new Error('Custom Item save Error'))
          })
        })
      })
    },
    // Previewボタン押下時
    compCustom () {
      if (!ch.checkSoldOut(this.custom.parts)) {
        this.showModal = true
        this.modalObject.title = '売り切れの商品が含まれています'
        this.modalObject.showOk = true
        return false
      }
      this.saveCustomData().then(() => {
        this.$router.push({ 'name': 'preview', params: { 'customID': this.custom.customID } })
      })
    },
    // Mirrorボタン押下時
    showSyncModal () {
      if (!ch.checkSoldOut(this.custom.parts)) {
        this.showModal = true
        this.modalObject.title = '売り切れの商品が含まれています'
        this.modalObject.showOk = true
        return false
      }
      this.saveCustomData().then(() => {
        this.isSyncModal = true
      })
    },
    // Mirror移行へ使うQRコードのモーダルを閉じた時
    hideSyncModal () {
      customMgr.getCustomItem(this.custom['customID']).then(custom => {
        this.custom = custom
        this.isSyncModal = false
      })
    }
  },
  created () {
    ch.setVue(this)
  },
  mounted () {
    // 初回表示のチュートリアルモーダルの表示フラグ
    if (customMgr.getStorage('isExplainModal_custom') === null) {
      this.isExplainModal = true
      customMgr.setStorage('isExplainModal_custom', true)
    }
    this.$nextTick(() => {
      ch.loadFonts(this.item.parts.find(element => element.type === 'type3'))
      ch.createStage('canvas-board')
      this.canvasWidth = document.getElementById('canvasWrap').clientWidth
      this.canvasHeight = document.getElementById('canvasWrap').clientHeight
      ch.resizeStage(this.canvasWidth, this.canvasHeight)
      ch.createContainer()
      window.addEventListener('resize', () => {
        this.canvasWidth = document.getElementById('canvasWrap').clientWidth
        this.canvasHeight = document.getElementById('canvasWrap').clientHeight
        ch.resizeStage(this.canvasWidth, this.canvasHeight)
        ch.resizeBitmap()
      }, false)
      ch.drawBitmapToStage(this.item.parts, this.custom.parts, this.sceneNum)
    })
  }
}
</script>

<style lang="scss" scoped>
.custom {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: fixed;
  background: url("../assets/images/custom/custom-bg.png");
  &__head {
    @include pageTitle;
    height: 45px;
    background: $black;
    position: relative;
    z-index: 10;
    &__close {
      position: absolute;
      color: $base-white;
      font-size: 12px;
      padding-left: 18px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        width: 12px;
        height: 12px;
        background: url("../assets/images/custom/custom-close.svg") top left
          no-repeat;
        background-size: 12px 12px;
        margin-top: -6px;
      }
    }
    &__sub {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      &__bl {
        width: auto;
        height: 100%;
        margin-left: 2px;
      }
    }
  }
  &__menu {
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 10;
    &__display {
      padding: 10px 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &__left {
        flex-basis: auto;
        &__logo {
          width: 150px;
          height: 25px;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: left;
          }
        }
        &__price {
          font-size: 24px;
          font-weight: bold;
          margin-top: 10px;
        }
      }
      &__scale {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &__icn {
          width: 50px;
          height: 50px;
          margin-left: 5px;
          margin-top: 5px;
        }
      }
    }
    &__panel {
      &__2 {
        display: none;
        background-color: #4a4a4a;
        padding: 15px 0;
        position: relative;
        &:before {
          position: absolute;
          z-index: 10;
          top: 0;
          bottom: 0;
          left: 0;
          width: 20px;
          content: '';
          display: block;
          background: -moz-linear-gradient(left, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
          background: -webkit-linear-gradient(left, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
          background: linear-gradient(to right, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
        }
        &:after {
          position: absolute;
          z-index: 10;
          top: 0;
          bottom: 0;
          right: 0;
          width: 20px;
          content: '';
          display: block;
          background: -moz-linear-gradient(right, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
          background: -webkit-linear-gradient(right, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
          background: linear-gradient(to left, #4a4a4a 20%, rgba(#4a4a4a, 0.6) 40%, rgba(#4a4a4a, 0));
        }
        &.is-active {
          display: block;
        }
        &__ct {
          &__vals {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: nowrap;
            overflow-x: auto;
            &::-webkit-scrollbar {
              height: 7px;
              background: #000000;
            }
            &::-webkit-scrollbar-thumb {
              background: rgba(#cccccc, 0.8);
            }
            @include mq-down() {
              &::-webkit-scrollbar {
                display: none;
              }
            }
            &__val {
              margin-right: 10px;
              &:first-child {
                margin-left: 20px;
              }
              padding: 5px;
              &__img {
                width: 60px;
                height: 60px;
                margin: auto;
                img {
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                }
              }
              dt,
              dd:last-child {
                line-height: 1.2;
                white-space: nowrap;
                color: $base-white;
                text-align: center;
                margin-top: 5px;
                font-size: 11px;
              }
              dt {
                margin-top: 10px;
              }
              &.is-active {
                pointer-events: none;
                position: relative;
                &::after {
                  position: absolute;
                  top: 0;
                  left: 0;
                  width: 100%;
                  height: 70px;
                  content: '';
                  background-color: rgba($right-gray, 0.3)
                }
              }
              &.is-sold {
                pointer-events: none;
                position: relative;
                &::before {
                  background-color: rgba(#4a4a4a, 0.6);
                  position: absolute;
                  top: 0;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  display: flex;
                  margin-top: -15px;
                  justify-content: center;
                  align-items: center;
                  content: 'SOLD OUT';
                  font-size: 14px;
                  font-weight: bold;
                  color: $base-white;
                  text-align: center;
                }
              }
              &.non-selectable {
                pointer-events: none;
              }
              &:last-child {
                padding-right: 20px;
                &.is-active::after {
                  width: calc(100% - 20px);
                }
              }
            }
          }
        }
      }
      &__1 {
        background-color: $base-black;
        &__ct {
          display: flex;
          overflow-x: scroll;
          &::-webkit-scrollbar {
            display: none;
          }
          &__item {
            color: $base-white;
            font-size: 13px;
            padding: 18px 25px;
            white-space: nowrap;
            &.is-active {
              background-color: #4a4a4a;
            }
          }
        }
      }
    }
  }
}

.canvas {
  height: calc(100% - 300px);
  &__info {
    padding: 20px;
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;
    &__txt {
      font-size: 12px;
      display: inline-block;
      padding: 7px 25px;
      color: $base-white;
      border-radius: 5px;
      background-color: rgba(0, 0, 0, 0.5);
    }
    &__msg {
      color: $dark-gray;
      font-size: 14px;
      font-weight: bold;
      position: absolute;
      bottom: -10px;
      text-align: center;
    }
  }
  &__area {
    height: calc(100% - 70px);
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: visible;
    &__wrap {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      &__item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__left,
    &__right {
      position: absolute;
      top: 50%;
      margin-top: -15px;
      width: 35px;
      height: 35px;
    }
    &__left {
      left: 5px;
    }
    &__right {
      right: 5px;
    }
    .partsImageLoading,
    .partsImageLoading:before,
    .partsImageLoading:after {
      background: rgba($dark-gray, 0.7);
      -webkit-animation: load1 1s infinite ease-in-out;
      animation: load1 1s infinite ease-in-out;
      width: 1em;
      height: 4em;
    }
    .partsImageLoading {
      color: rgba($dark-gray, 0.7);
      text-indent: -9999em;
      position: absolute;
      font-size: 11px;
      -webkit-transform: translateZ(0);
      -ms-transform: translateZ(0);
      transform: translateZ(0);
      -webkit-animation-delay: -0.16s;
      animation-delay: -0.16s;
    }
    .partsImageLoading:before,
    .partsImageLoading:after {
      position: absolute;
      top: 0;
      content: '';
    }
    .partsImageLoading:before {
      left: -1.5em;
      -webkit-animation-delay: -0.32s;
      animation-delay: -0.32s;
    }
    .partsImageLoading:after {
      left: 1.5em;
    }
    @-webkit-keyframes load1 {
      0%,
      80%,
      100% {
        box-shadow: 0 0;
        height: 4em;
      }
      40% {
        box-shadow: 0 -2em;
        height: 5em;
      }
    }
    @keyframes load1 {
      0%,
      80%,
      100% {
        box-shadow: 0 0;
        height: 4em;
      }
      40% {
        box-shadow: 0 -2em;
        height: 5em;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Custom.vue